import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <React.Fragment>
      <Router>
        <App />
      </Router>
        
    </React.Fragment>,
  document.getElementById('root')
);

serviceWorker.unregister();